import PrayerTimesWidget from "@/components/PrayerTimesWidget";

export default function PrayerTimesPage() {
  return (
    <div data-testid="prayer-times-page">
      <section className="py-16 md:py-24 px-6 md:px-10">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-10">
            <div className="text-[11px] uppercase tracking-[0.25em] text-gold font-semibold">Worship</div>
            <h1 className="display text-5xl md:text-6xl mt-4 text-ink">Prayer Times</h1>
          </div>
          <PrayerTimesWidget />
          <div className="mt-10 rounded-3xl bg-white border border-sand p-2 overflow-hidden">
            <iframe
              title="Monthly timetable"
              src="https://timing.athanplus.com/masjid/widgets/monthly?masjid_id=E5Avv2AX&theme=3"
              className="w-full rounded-2xl"
              style={{ height: "720px", border: 0 }}
              loading="lazy"
            />
          </div>
        </div>
      </section>
    </div>
  );
}
